export default __webpack_public_path__ + "static/hero-mobile@2x-86c42c0be40ad2b7324a6349ce3141f6.png";